import { FC } from 'react';
import { DataCellProps } from '../types';

// Define a mapping object for roles
const roleMapping: Record<string, string> = {
  'Workload Planner (View Only)': 'Work Planner (View Only) - All',
  'Workload Planner (View Only) - Base': 'Work Planner (View Only) - Project Member',
  'Workload Planner (View Only) - Project Manager': 'Work Planner (View Only) - Project Manager',

  'Financial Manager (View Only)': 'Budget Manager (View Only) - All',
  'Financial Manager (View Only) - Base': 'Financial Manager (View Only) - Project Member',
  'Financial Manager (View Only) - Project Manager': 'Budget Manager (View Only) - Project Manager',

  'Workload Planner': 'Work Planner (Can Edit) - All',
  'Workload Planner - Base': 'Work Planner (Can Edit) - Project Member',
  'Workload Planner - Project Manager': 'Work Planner (Can Edit) - Project Manager',

  'Financial Manager': 'Budget Manager (Can Edit) - All',
  'Financial Manager - Base': 'Budget Manager (Can Edit) - Project Member',
  'Financial Manager - Project Manager': 'Budget Manager (Can Edit) - Project Manager',

  Login: 'Project Guest / External Contractor',
  'Team Member': 'Base Member - All / Internal Contractor',
  'Team Member - No Access': 'Base Member - No Access',
};

export const TeamMemberRoleCell: FC<DataCellProps> = ({ _customRowProps, member }) => {
  // Map the role to the custom text, or fallback to the original role if not found
  const mappedRole = roleMapping[member.role_name] || member.role_name;

  return <div>{mappedRole}</div>;
};
